import $ from 'jquery';
import config, { baseUrl } from './config'
import { Redirect } from 'react-router-dom';
import React from 'react';
import axios from 'axios';
import qs from 'querystring';
let ip ;

 
export async function apiService(url, request, successCall, errorCall) {
  console.log('apiService url:', url);
  if(url.includes('/activitytracking')) request.activity_tracking_token = localStorage.getItem('activity_tracking_token')
  request.token = localStorage.getItem('token');
  request.ip= JSON.parse(localStorage.getItem("deviceInfo"))?JSON.parse(localStorage.getItem("deviceInfo"))['ip']:null;
    $.ajax({
        url: url,
        type: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: request,
        success: (data) => {
            successCall(data)
        },
        error : (data) => {            
            if(data.status === 403 || data.status === 401) {                
                const loginPath = localStorage.getItem('loggedInType')
                localStorage.clear()
                localStorage.setItem('pathName', window.location.pathname + window.location.search)
                if(loginPath==="Danskespil"){
                    location.replace('/loggedOut')
                }else {
                    location.replace('/')
                }
            } 
            if(data.status === 406 && request.assertionId ) {
                location.replace('/loggedOut')
            }
            console.log('Not Able To Call APi.....', JSON.stringify(data));            
            errorCall(data)         
        }
    })
  }

export function axiosCallService(url, payload={}) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'POST',
            url: baseUrl + url,
            data: qs.stringify({ "token": localStorage.getItem('token'), ...payload })
        }).then(resolve)
            .catch(({ response }) => {
                console.log("response",response);
                if (response.status == 403) {
                    localStorage.clear()
                    localStorage.setItem('pathName', window.location.pathname + window.location.search)
                    if(localStorage.getItem('loggedInType')==="Dnskespil"){
                        location.replace('/loggedOut')
                    }else {
                        location.replace('/')
                    }
                }
                reject();
            })
    })
}

// export function axiosCallServiceForFileUpload(url,data) {
//     console.log("data",data);
//     return new Promise((resolve, reject) => {
// console.log("formData",data);
//         axios.post(baseUrl + url, data,{
//             headers: {
//                 'content-type': 'multipart/form-data',
//                 'x-access-token':localStorage.getItem('token')
//             }}).then(resolve)
//             .catch(({ response }) => {
//                 console.log("response",response);
//                 if (response.status == 403) {
//                     localStorage.clear()
//                     localStorage.setItem('pathName', location.href)
//                     location.replace('/')
//                 }
//                 reject();
//             })
//     })
// }


/** WEBPACK FOOTER **
 ** ./src/common/apiCallService.js
 **/